import { HttpErrorResponse } from '@angular/common/http';

/**
 * Extract error message from backend API error response
 * 
 * Backend standard format: { "code": "error_type", "message": "...", "details": {} }
 * Special case: message can be an object like { "detail": "..." }
 * 
 * @param error - The error object from HTTP request
 * @param fallbackMessage - Fallback message if extraction fails
 * @returns Human-readable error message
 */
export function extractErrorMessage(error: any, fallbackMessage: string = 'An unexpected error occurred'): string {
  // Handle HttpErrorResponse from Angular
  if (error instanceof HttpErrorResponse && error.error) {
    // Check if message is an object with detail property
    if (error.error.message && typeof error.error.message === 'object' && error.error.message.detail) {
      return error.error.message.detail;
    }
    // Backend standard format: { "message": "..." }
    if (error.error.message && typeof error.error.message === 'string') {
      return error.error.message;
    }
  }
  
  // Handle standard Error objects
  if (error instanceof Error) {
    return error.message;
  }
  
  // Fallback
  return fallbackMessage;
}
